var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLHiwLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5624_9285)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 12,
    fill: "#868EAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.196 54H27.136V42.678H14.692V54H11.632V29.724H14.692V39.992H27.136V29.724H30.196V54ZM43.6672 54H34.8952V52.232L37.7512 51.586V32.172L34.8952 31.492V29.724H43.6672V31.492L40.8112 32.172V51.586L43.6672 52.232V54ZM76.2346 29.724L69.7746 54H66.6806L61.9546 38.088C61.8186 37.612 61.6826 37.1247 61.5466 36.626C61.4106 36.1273 61.286 35.6513 61.1726 35.198C61.0593 34.7447 60.9573 34.3593 60.8666 34.042C60.7986 33.702 60.7533 33.4527 60.7306 33.294C60.708 33.4527 60.6626 33.702 60.5946 34.042C60.5493 34.3593 60.47 34.7447 60.3566 35.198C60.2433 35.6513 60.1186 36.1387 59.9826 36.66C59.8693 37.1587 59.7333 37.6687 59.5746 38.19L54.9846 54H51.8906L45.4646 29.724H48.6606L52.4346 44.548C52.5706 45.0693 52.6953 45.5907 52.8086 46.112C52.922 46.6107 53.024 47.1093 53.1146 47.608C53.228 48.084 53.3186 48.5487 53.3866 49.002C53.4546 49.4553 53.5226 49.8973 53.5906 50.328C53.6586 49.8747 53.7266 49.41 53.7946 48.934C53.8853 48.458 53.9873 47.9707 54.1006 47.472C54.214 46.9507 54.3386 46.4293 54.4746 45.908C54.6106 45.3867 54.7466 44.8767 54.8826 44.378L59.1666 29.724H62.3286L66.7826 44.48C66.9413 45.0013 67.0886 45.534 67.2246 46.078C67.3606 46.5993 67.4853 47.1093 67.5986 47.608C67.712 48.1067 67.8026 48.594 67.8706 49.07C67.9613 49.5233 68.0406 49.9427 68.1086 50.328C68.1766 49.7613 68.2673 49.172 68.3806 48.56C68.494 47.9253 68.63 47.268 68.7886 46.588C68.9473 45.908 69.1173 45.2167 69.2986 44.514L73.0386 29.724H76.2346Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5624_9285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLHiwLogo);
export default __webpack_public_path__ + "static/media/L_HIW_Logo.f73a4e2d4ec178816f10a47ae890cf15.svg";
export { ForwardRef as ReactComponent };